import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

function PrimaryButton({ children, to, href, className = "", showArrow = false, ...rest }) {
  const sharedClassName = `btn-glow group relative inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3.5 text-sm font-semibold tracking-wide shadow-card transition-all duration-300 hover:-translate-y-0.5 hover:shadow-glow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 ${className}`.trim();

  const content = (
    <>
      <span className="relative z-10 flex items-center gap-2">
        {children}
        {showArrow && (
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        )}
      </span>
    </>
  );

  if (to) {
    return (
      <Link className={sharedClassName} to={to} {...rest}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a className={sharedClassName} href={href} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button className={sharedClassName} type="button" {...rest}>
      {content}
    </button>
  );
}

export default PrimaryButton;
